import { Data } from '@blade/std-lib'

export class Version extends Data.TaggedClass('Version')<{
  version: string
}> {}

export class UnknownVersion extends Data.TaggedClass('UnknownVersion') {}

export type AppVersion = Version | UnknownVersion

export const match = Data.matchFor<AppVersion>()
